import React, { Component } from 'react';

import Title from '../../components/Title';
import Conteudo from '../../Conteudo';

import ListaSolicitacoes from './ListaSolicitacoes';
import ListaSolicitacoesPorCompetencia from './ListaSolicitacoesPorCompetencia';

export default class extends Component {
  render () {
    return (<div>
      <Title value="Diego Rivera » Água Mineral" />
      <Conteudo>
        <ListaSolicitacoes />
        <ListaSolicitacoesPorCompetencia />
      </Conteudo>
  </div>);
  }
}


// WEBPACK FOOTER //
// ./src/modules/aguaMineral/Index.js